export default __webpack_public_path__ + "static/media/The OG Shop - Final.ac5be6fa.jpg";